import { useEffect, useState } from 'react';

import { useApi } from './useApi.hook';

export function useAccessToken(): string|null {
    const { client } = useApi();
    const [ accessToken, setAccessToken ] = useState(() => client.getAccessToken());

    useEffect(() => {
        const handleChange = () => {
            setAccessToken(client.getAccessToken());
        };

        client.addEventListener('tokenUpdated', handleChange);
        client.addEventListener('sessionEstablished', handleChange);
        client.addEventListener('sessionExpired', handleChange);
        client.addEventListener('sessionDeleted', handleChange);

        return () => {
            client.removeEventListener('tokenUpdated', handleChange);
            client.removeEventListener('sessionEstablished', handleChange);
            client.removeEventListener('sessionExpired', handleChange);
            client.removeEventListener('sessionDeleted', handleChange);
        };
    }, [ client ]);

    return accessToken;
}
